/**
 * Lightweight funnel instrumentation.
 *
 * Events are pushed to the existing gtag/dataLayer queue that index.html
 * already sets up. No new third-party script, no change to the consent model —
 * if no analytics tag is loaded the events simply sit in the queue.
 */
import { gtagEvent } from '@/lib/analytics';

type FunnelEvent =
  | 'shop_view'
  | 'add_to_cart'
  | 'remove_from_cart'
  | 'view_cart'
  | 'begin_checkout'
  | 'purchase'
  | 'sample_requested'
  | 'look_inside'
  | 'newsletter_signup';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export const track = (event: FunnelEvent, params: Record<string, unknown> = {}) => {
  if (typeof window === 'undefined') return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    gtagEvent(event, params);
  } catch {
    /* analytics must never break the page */
  }
};
